import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { formatDate } from '../../utils/formatDate';
import type { Package } from '../../types';

interface DowngradeDialogProps {
  open: boolean;
  targetPackage: Package | null;
  currentPackageName?: string;
  endAt?: string;
  onClose: () => void;
  onConfirm: () => void;
}

export const DowngradeDialog: React.FC<DowngradeDialogProps> = ({
  open,
  targetPackage,
  currentPackageName,
  endAt,
  onClose,
  onConfirm,
}) => {
  const { t, i18n } = useTranslation();
  const formattedEndAt = endAt ? formatDate(endAt, i18n.language) : '';

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {t('subscription.downgradeDialog.title', { name: targetPackage?.name ?? '' })}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t('subscription.downgradeDialog.description', {
            current: currentPackageName ?? t('subscription.plan.currentGeneric'),
            date: formattedEndAt,
            name: targetPackage?.name ?? '',
          })}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          {t('subscription.downgradeDialog.keep')}
        </Button>
        <Button onClick={onConfirm} variant="contained">
          {t('subscription.downgradeDialog.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
